import { axios } from './axios';

export const getProductPricingAndNutrientInfo = async ({ meal_type }: { meal_type: string }) => {
  return axios
    .get<any>('/product_summary', {
      params: {
        meal_type,
      },
    })
    .then((res) => res.data);
};
